import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Modal from './modals/modal.component';
import classnames from 'classnames';
import FormControl from './forms/formControl.component';
import Input from '../shared/forms/input/input.component';

/* (?) Move shared/hooks */
const useInputState = initialValue => {
  const [value, setValue] = useState(initialValue);

  return [
    value,
    inputEvent => setValue(inputEvent.target.value),
  ];
};

export default function PromptDialog(props) {
  const [value, setValue] = useInputState('');

  const {
    onCancel, onConfirm,
    title = 'Please enter value',
    dismissText = 'Cancel',
    submitText = 'Set value',
    inputType = 'text',
    isVisible,
  } = props;

  const onDialogConfirm = useCallback(
    () => onConfirm(value),
    [onConfirm, value]
  );

  return (
    <Modal
      className={classnames('prompt-dialog-modal')}
      title={title}
      closeAction={onCancel}
      dismissText={dismissText}
      dismissAction={onCancel}
      submitText={submitText}
      submitAction={onDialogConfirm}
      isVisible={isVisible}
    >
      <div>
        <form onSubmit={onDialogConfirm}>
          <FormControl
            type={inputType}
            value={value}
            onChange={setValue}
            label={''}
            name={'value'}
          >
            <Input type={inputType} name="value" onChange={setValue} autoFocus/>
          </FormControl>
        </form>
      </div>
    </Modal>
  );
}

PromptDialog.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  dismissText: PropTypes.string,
  submitText: PropTypes.string,
  inputType: PropTypes.string,
  isVisible: PropTypes.bool,
};
